import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VesselDpControl } from '../dto/vessel-dp-control';

@Injectable({
  providedIn: 'root'
})
export class VesselDpControlService {

  private apiUrl = environment.apiRoot + '/vesseldpcontrol';

  constructor(private http: HttpClient) { }

  getAllDpControlsOfVessel(vesselId: number): Observable<VesselDpControl[]> {
    return this.http.get<VesselDpControl[]>(this.apiUrl + '/allofvessel?vesselId=' + vesselId);
  }

  createDpControl(vesselId: number): Observable<VesselDpControl> {
    let model = { "id": 0, "vessel_id": vesselId, "name": "new DpControl" };
    return this.http.post<VesselDpControl>(this.apiUrl + '/new', model);
  }

  updateDpControl(model: VesselDpControl): Observable<VesselDpControl> {
    return this.http.put<VesselDpControl>(this.apiUrl + '/update', model);
  }

  deleteDpControl(dpControlId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?dpControlId=' + dpControlId);
  }
}
